import { render, staticRenderFns } from "./PotentialClients.vue?vue&type=template&id=3ec39fac&"
import script from "./PotentialClients.vue?vue&type=script&lang=js&"
export * from "./PotentialClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports